import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import { openForm } from '../../../../../../../../modules/actions/forms'

import { UPDATE_CUSTOM_FILE_UPLOAD_DATES } from '../../../../../../../../constants/forms'

import useStyles from './styles'

const StartDateHeader = ({ bookedMediaId }) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const openEditCustomDatesFormHandler = useCallback(() => {
    dispatch(
      openForm({
        formName: UPDATE_CUSTOM_FILE_UPLOAD_DATES,
        id: bookedMediaId
      })
    )
  }, [dispatch, bookedMediaId])

  return (
    <div onClick={openEditCustomDatesFormHandler}>
      Start Date ({<span className={classes.customise}>Customise</span>})
    </div>
  )
}

StartDateHeader.propTypes = {
  bookedMediaId: PropTypes.number.isRequired
}

export default StartDateHeader
